/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { StartExecutionResponse } from './StartExecutionResponse';
import {
    StartExecutionResponseFromJSON,
    StartExecutionResponseFromJSONTyped,
    StartExecutionResponseToJSON,
} from './StartExecutionResponse';

/**
 * 
 * @export
 * @interface StartExecution202Response
 */
export interface StartExecution202Response {
    /**
     * 
     * @type {StartExecutionResponse}
     * @memberof StartExecution202Response
     */
    data?: StartExecutionResponse;
}

/**
 * Check if a given object implements the StartExecution202Response interface.
 */
export function instanceOfStartExecution202Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StartExecution202ResponseFromJSON(json: any): StartExecution202Response {
    return StartExecution202ResponseFromJSONTyped(json, false);
}

export function StartExecution202ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StartExecution202Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : StartExecutionResponseFromJSON(json['data']),
    };
}

export function StartExecution202ResponseToJSON(value?: StartExecution202Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': StartExecutionResponseToJSON(value.data),
    };
}

